
import styles from "./IFrameWrapper.module.css"
import { closeClasseraLogin }from "../features/webgl/classeraWebView.js"
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useRef } from "react";
import leftIcon from "../images/left-icon.svg"

export default function ClasseraIFrameWrapper() {
    const dispatch = useDispatch();
    
    useEffect(() => {
        const handleKeyDown = (event) => {
            if(event.key === 'Escape') {
                dispatch(closeClasseraLogin())
            }
        };
        document.addEventListener("keydown", handleKeyDown, false);
        return () => document.removeEventListener("keydown", handleKeyDown, false);
    }, [dispatch])

    const ref1 = useRef(null);
    
    const isOpen = useSelector((state) => state.classeraWebView.open);

    const iframe = process.env.REACT_APP_CLASSERA_IFRAME;

    const onIFrameLoaded = () => {
        console.log("IFrame location : " + ref1.current.src);
    }

    return (<div className={styles.player} hidden={!isOpen} onClick={() => dispatch(closeClasseraLogin())} >
        <iframe title="Classera SSO Login" src={iframe} ref={ref1} loading="lazy" onLoad={() => onIFrameLoaded()} />
        <img src={leftIcon} alt="backIcon"  onClick={() => dispatch(closeClasseraLogin())} className={styles.lefticon} />
    </div>);
}
